import { USER_DETAILS } from './kyc.types';
export const addUserDetails =(data)=>{
    // console.warn("action",data)
    return {
        type:USER_DETAILS,
        data:data
    }
}
